import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { baseQuery } from '../base/baseQuery'

export const subjectServiceApi = createApi({
  reducerPath: 'subjectServiceApi',
  baseQuery: baseQuery,
  tagTypes: ['Subject'],
  endpoints: (builder) => ({
    // Fetch all subjects for a module
    // Fetch all subjects for a module
    getSubjectsByModuleId: builder.query({
      query: (moduleId) => `/backoffice/modules/${moduleId}/subjects`,
      providesTags: (result, error, moduleId) =>
        result
          ? [
              ...result.data.map(({ id }) => ({ type: 'Subject', id })),
              { type: 'Subject', id: 'LIST' },
            ]
          : [{ type: 'Subject', id: 'LIST' }],
    }),
    // Add a new subject
    addSubject: builder.mutation({
      query: (newSubject) => ({
        url: '/backoffice/subjects/save',
        method: 'POST',
        body: newSubject,
      }),
      invalidatesTags: [{ type: 'Subject', id: 'LIST' }],
    }),
    // Update a subject
    updateSubject: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/backoffice/subjects/update/${id}`,
        method: 'Put',
        body: formData,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: 'Subject', id },
        { type: 'Subject', id: 'LIST' },
      ],
    }),
    // Delete a subject
    deleteSubject: builder.mutation({
      query: (id) => ({
        url: `/backoffice/subjects/delete/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: (result, error, id) => [{ type: 'Subject', id: 'LIST' }],
    }),
  }),
})

export const {
  useGetSubjectsByModuleIdQuery,
  useAddSubjectMutation,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation,
} = subjectServiceApi
